import React, { lazy } from 'react';

// Lazy load components for better performance
// Authentication & Core components - FIXED IMPORT PATTERNS
export const Auth = lazy(() => import('./Auth').then(module => ({ default: module.Auth }))); // Named export
export const Dashboard = lazy(() => import('./Dashboard')); // Default export
export const PrivateRoute = lazy(() => import('./PrivateRoute').then(module => ({ default: module.PrivateRoute }))); // Named export  
export const ProtectedRoute = lazy(() => import('./ProtectedRoute')); // Default export

// Layout components - All use default exports
export const BackendLayout = lazy(() => import('./BackendLayout'));
export const DashboardLeftNav = lazy(() => import('./DashboardLeftNav'));
export const AdminLeftNav = lazy(() => import('./AdminLeftNav'));
export const Header = lazy(() => import('./Header'));
export const Footer = lazy(() => import('./Footer'));
// export const EvaluationHeader = lazy(() => import('./EvaluationHeader'));

// Management components - All use default exports
export const OrganizationManagement = lazy(() => import('./OrganizationManagement'));
export const UserManagement = lazy(() => import('./UserManagement'));
export const UserCreation = lazy(() => import('./UserCreation'));
export const UserListPage = lazy(() => import('./UserListPage'));
export const EditUserPage = lazy(() => import('./EditUserPage'));
export const AllUsersListPage = lazy(() => import('./AllUsersListPage'));
export const EditAllUserPage = lazy(() => import('./EditAllUserPage'));
export const AdminUserListPage = lazy(() => import('./AdminUserListPage'));
export const AdminEditUserPage = lazy(() => import('./AdminEditUserPage'));
export const DealerManagement = lazy(() => import('./DealerManagement'));
export const RoleManagement = lazy(() => import('./RoleManagement'));
export const DatabaseManagement = lazy(() => import('./DatabaseManagement'));

// Backend components - All use default exports
export const BackendLandingPage = lazy(() => import('./BackendLandingPage'));
export const BackendSettings = lazy(() => import('./BackendSettings'));
export const OrganizationSettings = lazy(() => import('./OrganizationSettings'));
export const AuctionsPage = lazy(() => import('./AuctionsPage'));
export const AuctionHelper = lazy(() => import('./AuctionHelper'));
export const SupplierConverterPage = lazy(() => import('../pages/SupplierConverterPage'));
export const AddInventoryPage = lazy(() => import('../pages/AddInventoryPage'));

// MSG91 Notification components
export const MSG91Notifications = lazy(() => import('./MSG91Notifications'));
export const MSG91Config = lazy(() => import('./MSG91Config'));

// Mapping components
export const BDMCityMapping = lazy(() => import('./BDMCityMapping'));
export const DealerCityMapping = lazy(() => import('./DealerCityMapping'));

// Role-based components
export const DealerHome = lazy(() => import('./DealerHome'));
export const EvaluatorHome = lazy(() => import('./EvaluatorHome'));

// OTP Verification components
export const OTPVerificationPage = lazy(() => import('./otp-verification/OTPVerificationPage'));
export const OTPGate = lazy(() => import('./OTPGate'));
export const OTPGateHTML = lazy(() => import('./OTPGateHTML'));
export const OTPGateBackend = lazy(() => import('./OTPGateBackend'));

// Management modules
export const ManageDrivers = lazy(() => import('./ManageDrivers'));
export const ManageSuppliers = lazy(() => import('./ManageSuppliers'));
export const FavoritesPage = lazy(() => import('./FavoritesPage'));

// Master data components
export const SupplierMaster = lazy(() => import('./SupplierMaster'));
export const YardMaster = lazy(() => import('./YardMaster'));
export const SteeringWheelMaster = lazy(() => import('./SteeringWheelMaster'));
export const VehicleSpecMaster = lazy(() => import('./VehicleSpecMaster'));
export const BannerMaster = lazy(() => import('./BannerMaster'));
export const OverlayMaster = lazy(() => import('./OverlayMaster'));
export const CarTypeMaster = lazy(() => import('./CarTypeMaster'));
export const FeaturedCarsMaster = lazy(() => import('./FeaturedCarsMaster'));
export const TypeAngleForm = lazy(() => import('./TypeAngleForm'));

// Evaluation system
export const YardEvaluationLinkGenerator = lazy(() => import('./YardEvaluationLinkGenerator'));
export const EvaluationOTP = lazy(() => import('./EvaluationOTP'));
export const EvaluationYards = lazy(() => import('./EvaluationYards'));
export const EvaluationCars = lazy(() => import('./EvaluationCars'));
export const EvaluationPhotoUpload = lazy(() => import('./EvaluationPhotoUpload'));
export const EvaluationPage = lazy(() => import('../pages/EvaluationPage'));

// Workflow and state machine components


// Car management
export const MyCars = lazy(() => import('./MyCars'));
export const MyCarsV2 = lazy(() => import('./MyCarsV2'));
export const BDMCarsV2 = lazy(() => import('./BDMCarsV2'));

// Finance components
export const FinanceApproval = lazy(() => import('./FinanceApproval'));
export const FinanceApprover = lazy(() => import('./FinanceApprover'));
export const HeadFinanceApprover = lazy(() => import('./HeadFinanceApprover'));
export const DepositRefundTracking = lazy(() => import('./DepositRefundTracking'));
export const NOCManagement = lazy(() => import('./NOCManagement'));

// Inventory management
export const ManageInventory = lazy(() => import('./ManageInventory'));

// Quote Admin
export const QuoteAdmin = lazy(() => import('./QuoteAdmin'));

// Delivery components
export const DeliveryPage = lazy(() => import('./DeliveryPage'));

// Landing page
export const LandingPage = lazy(() => import('./LandingPage'));

// Error boundary
export const ErrorBoundary = lazy(() => import('./ErrorBoundary'));

// Analytics components
export const AnalyticsDashboard = lazy(() => import('./AnalyticsDashboard'));
export const AnalyticsTest = lazy(() => import('./AnalyticsTest'));

// Batch Job Manager
export const BatchJobManager = lazy(() => import('../pages/BatchJobManager'));
